<template>
  <div id="screen" class="w-screen h-screen overflow-x-hidden dark:bg-gray-900 flex flex-col">
    <section class="">
      <Nav/>
    </section>
    <section class="flex-1 dark:bg-gray-900 bg-gray-50">
      <span v-if="path === '/dashboard'">
        <Dash v-if="userRole === 'administrador'"/>
        <DashPesquisador v-if="userRole === 'pesquisador'"/>
      </span>
      <router-view v-else/>
    </section>
  </div>
</template>

<script>

import Nav from '@/components/Layout/Navbar'
import { useRoute } from 'vue-router'
import { computed } from '@vue/runtime-core'
import Dash from '../components/Dash/Dash.vue'
import DashPesquisador from '../components/Dash/DashPesquisador.vue'
import { useStore } from 'vuex'
export default {
  name: 'Dashboard',
  components: {
    Nav,
    Dash, DashPesquisador
  },
  setup() {
    const route = useRoute()
    const store = useStore()
    const userRole = store.getters['auth/user'].role
    const path = computed(() =>route.path)
    return {
      path,
      userRole
      
    }
  }
}
</script>

<style>

</style>